<template lang="html">
  <div>
    <div class="row mb-3">
      <div class="col-12">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="teachersForStudentsFilter"
          search-icon="fas fa-search"
          search-text="Buscar"
          search-container-class="butn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @type="getDisciplines"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <icon-view
          icon="far fa-history color-orange p-5"
          icon-size="1.5rem"
          title="Disciplinas"
          variant="icon-view-extended"
          class="mb-2 icon-view-color-text"
        />
      </div>
      <div class="col-12">
        <callout
          v-for="(discipline, index) in model.disciplines"
          :key="discipline.disciplineId"
          controlled
          has-toggle
          class="mb-2 callout-extended"
          :has-gradient="false"
          :opened="discipline.opened"
          border-color="#f7f7f7"
          @click:open="open(discipline, index)"
        >
          <div class="py-1">
            <div class="d-inline mr-2">
              <i class="fad fa-folder-open text-orange fa-lg-custom" />
            </div>
            <span class="color-gray-7 font-16 font-weight-bold">
              {{ discipline.disciplineDesc | empty }}
            </span>
          </div>
          <template #edition>
            <div class="p-2 bg-gray">
              <div class="py-3 px-2 bg-white">
                <callout
                  v-for="(item, idx) in discipline.items"
                  :key="idx"
                  :has-toggle="true"
                  :class="{ 'mt-3': idx > 0 }"
                  border-color="#B5C3BC"
                  controlled
                  :opened="item.opened"
                  @click:open="openDoc(item, index, idx)"
                >
                  <div class="row pt-1">
                    <div class="col-12 col-md-4">
                      <div class="data-title">Tipo de Evaluación:</div>
                      <p class="info-text">
                        {{ item.evaluationTypeDesc | empty }}
                      </p>
                    </div>
                    <div class="col-12 col-md">
                      <div class="data-title">Fecha de la Evaluación:</div>
                      <p class="info-text">
                        {{ item.evaluationDate | date }}
                        {{ item.evaluationDate | hour }}
                      </p>
                    </div>
                    <div
                      class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
                    >
                      <div class="align-self-center">
                        <action-button
                          text="Descargar"
                          variant="outline-success"
                          i="fas fa-file-download"
                          @click="download(item)"
                        />
                      </div>
                    </div>
                  </div>
                  <template #edition>
                    <div class="p-2 bg-gray">
                      <div class="p-3 bg-white">
                      <div class="col-md-12 bg-white rounded py-4">
                        <span class="w-100 pl-1 dark-gray font-weight-bolder">
                          <em class="fa fa-info-circle text-orange" />
                          Información General de la Cita
                        </span>

                        <div class="row mx-0 mt-4 px-2 mb-3">
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Estatus de Cita:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.appoitmentStatus"
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Número de Cita:"
                              label-class="text-gray font-weight-light"
                              :value="
                                $options.filters.appointmentFormat(
                                  model.detail?.appoitmentNumber?.toString()
                                )
                              "
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="CSEE:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.center"
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Teléfono de Proveedor:"
                              label-class="text-gray font-weight-light"
                              :value="
                                $options.filters.phone(
                                  model.detail?.providerPhone
                                )
                              "
                              class="font-weight-bold"
                            />
                          </div>
                        </div>
                        <div class="row mx-0 mt-4 px-2">
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Lugar:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.location"
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Especialista:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.specialist"
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Corporación:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.company"
                              class="font-weight-bold"
                            />
                          </div>
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Nombre de la Persona Contacto:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.contact"
                              class="font-weight-bold"
                            />
                          </div>
                        </div>
                        <div class="row mx-0 mt-4 px-2">
                          <div
                            class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                          >
                            <CustomInputDisplay
                              label="Dirección Física:"
                              label-class="text-gray font-weight-light"
                              :value="model.detail?.address"
                              class="font-weight-bold"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </template>
                </callout>
              </div>
            </div>
          </template>
        </callout>
      </div>
    </div>
  </div>
</template>
<script>
import FilterManager from "FilterManager";
import IconView from "icon-view";
import { CustomCollapse, CustomCollapseItem } from "@/components/common";
import Callout from "custom-callout";
import ActionButton from "ActionButton";
import CustomInputDisplay from "CustomInputDisplay";

import academicYearService from "@/services/academicyear";
import ReferralService from "@/modules/referral/api";
import DocumentsService from "@/services/documents";
import codeService from "@/modules/common/code.api";
import serviceTypes from "@/utils/constants/service-types";

export default {
  name: "RecordEvaluations",
  components: {
    FilterManager,
    IconView,
    CustomCollapse,
    CustomCollapseItem,
    Callout,
    ActionButton,
    CustomInputDisplay
  },
  props: {
    studentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      model: {
        search: {
          filters: {
            academicYear: null,
            type: null,
            therapy: null
          },
          collections: {
            academicYears: [],
            types: [],
            therapies: []
          }
        },
        disciplines: [],
        detail: {}
      }
    };
  },
  computed: {
    filterManagerConfig() {
      return [
        {
          name: "academicYear",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          placeholder: "Año Académico",
          error: "El año académico es requerido.",
          class: "col-12 col-lg-4",
          clearable: true,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear
        },
        {
          name: "type",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          placeholder: "Tipo de Evaluación",
          class: "col-12 col-lg-4",
          clearable: true,
          options: this.model.search.collections.types,
          value: this.model.search.filters.type,
          disabled: this.model.search.collections.types.length == 1
        },
        {
          name: "therapy",
          component: "custom-drop-down",
          fieldKey: "id",
          fieldName: "name",
          placeholder: "Disciplina",
          clearable: false,
          class: "col-12 col-lg-4",
          clearable: true,
          options: this.model.search.collections.therapies,
          value: this.model.search.filters.therapy,
          disabled: this.model.search.collections.therapies.length == 1
        }
      ];
    }
  },
  mounted() {
    this.initFilters();
    this.onHandlerSearch();
  },
  methods: {
    async initFilters() {
      const { data } = await ReferralService.getRecordEvaluationFilterOptions(this.studentId);
      this.model.search.collections.academicYears = data.academicYears;
      this.model.search.collections.types = data.evaluationTypes;
    },
    async getDisciplines(serviceType){
      const {id} = serviceType || {};
      if (!id) {
        this.model.search.collections.therapies = [];
        return;
      }
      const data = await codeService.getDisciplineTypes({
        serviceTypeIds: [id]
      });
      this.model.search.collections.therapies = data;
    },
    async onHandlerSearch() {
      if (!this.studentId) {
        return;
      }

      const payload = {
        disciplineId: this.model.search.filters.therapy?.id,
        academicYearId: this.model.search.filters.academicYear?.id,
        evaluationTypeId: this.model.search.filters.type?.id
      };

      const { data: results } = await ReferralService.getRecordEvaluation(
        this.studentId,
        payload
      );
      this.model.disciplines = results.map(x => ({
        ...x,
        items: x.items.map(y => ({
          ...y,
          opened: false
        })),
        opened: false
      }));
    },
    async open(item, key) {
      this.model.disciplines
        .filter((x, i) => i !== key)
        .forEach(x => (x.opened = false));
      setTimeout(() => (item.opened = !item.opened), 100);
    },
    async openDoc(doc, disciplineIdx, itemIdx) {
      this.model.disciplines[disciplineIdx].items
        .filter((x, i) => i !== itemIdx)
        .forEach(x => (x.opened = false));
      if (!doc.opened) {
        this.getDetail(doc.clientAppointmentId);
      }
      doc.opened = !doc.opened;
    },
    download(item) {
      const { documentId, documentAttachmentId } = item;
      const id = documentId || documentAttachmentId;
      DocumentsService.downloadFromServer(id);
    },
    async getDetail(id) {
      if (!id) return;
      const { data } = await ReferralService.getRecordEvaluationDetail(id);
      this.model.detail = data;
    }
  },
  watch: {
    studentId(newValue) {
      if (newValue) {
        this.onHandlerSearch();
        this.initFilters();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep {
  .icon-view-extended {
    margin-bottom: 0.5rem;
    .dot {
      margin-right: 0.5rem !important;
      width: 40px !important;
      height: 40px !important;
      .title-icon {
        margin: 0 !important;
      }
    }
    .font-16.color-gray-7 {
      font-size: 24px !important;
    }
  }
}

.callout-extended ::v-deep .col.p-2 > .col-12 {
  border-left: 1px solid #e2e2e2;
}
</style>
